import { render } from "./CdaVisitableItem.vue?vue&type=template&id=689705b2&scoped=true"
import script from "./CdaVisitableItem.vue?vue&type=script&lang=js"
export * from "./CdaVisitableItem.vue?vue&type=script&lang=js"

import "./CdaVisitableItem.vue?vue&type=style&index=0&id=689705b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689705b2"]])

export default __exports__